import { useState } from "react";
import { BrandLogo } from "@/components/BrandLogo";
import { Loader2 } from "lucide-react";
import { api, errorText } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";

// "Forgot password" step on the login page: always shows the same neutral confirmation.
export function ForgotPasswordForm({ initialEmail, onBack }) {
  const [email, setEmail] = useState(initialEmail || "");
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState("");
  const [error, setError] = useState("");
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setError("");
    try {
      const { data } = await api.post("/auth/forgot-password", { email });
      setSent(data.message);
    } catch (err) { setError(errorText(err)); }
    setBusy(false);
  };
  return (
    <form onSubmit={submit} className="space-y-5" data-testid="forgot-form">
      <BrandLogo />
      <div>
        <h1 className="font-display text-4xl font-extrabold uppercase">Reset password</h1>
        <p className="text-sm text-slate-400 mt-1">Enter your account email and we'll send you a link to choose a new password.</p>
      </div>
      {sent ? (
        <p className="text-sm text-emerald-300 rounded-md border border-emerald-500/40 bg-emerald-950/30 p-3" data-testid="forgot-sent">{sent}</p>
      ) : (
        <>
          <Input data-testid="forgot-email-input" type="email" placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} required className="h-11 bg-slate-900/70" />
          {error && <p data-testid="forgot-error" className="text-sm text-rose-400">{error}</p>}
          <Button data-testid="forgot-submit-btn" type="submit" disabled={busy} className="w-full h-11 bg-blue-600 hover:bg-blue-500 font-semibold">
            {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : "Send reset link"}
          </Button>
        </>
      )}
      <button type="button" data-testid="forgot-back-btn" onClick={onBack} className="text-sm font-semibold text-blue-400 hover:text-blue-300 transition-colors">
        Back to sign in
      </button>
    </form>
  );
}
